import { useReducer } from 'react'
import { BigNumber, constants, providers } from 'ethers'

import { ClientWallet } from './useClientWallet'
import configs, { config } from 'configs'

const readonly = new providers.JsonRpcProvider(config<string>('rpc-url', ''))

export interface AppGlobalState {
  configs: any

  balances: {
    [token: string]: {
      amount: BigNumber
      decimals: number
      display: string
    }
  }
  gladiator: {
    total: string
    claimables: string
    lastSeen: Date | null
    weekPlayed: string
    champions: {
      address: string|null
      ratio: number
      claimable?: number
      weekPlayed?: number
    }[]
    // Cashback properties
    secondsPerRound?: number
    lastRound?: number
    nextRound?: number
  }
  knight: {
    pmtAllowance: BigNumber
    queenId: number
    seatFee: number // 0.05 = 5%
    // currentIndex: BigNumber | null
    // totalPrincipal: number
    maxBet: number
    punishRatio: number // 0.05 = 5%
    minJoin: number
    list: {
      id: number
      owner: string | null
      amount: number
      since: number // Unix timestamp
      startIndex: BigNumber
      profit: number
      error?: boolean
    }[]
  }

  network: any
  error?: Error | string | null
  actions: {
    [action: string]: (...args: any) => any
  }
  wallet: ClientWallet
}

export const initState: AppGlobalState = {
  configs,
  balances: {
    PMT: { amount: constants.Zero, decimals: 18, display: 'PMT' },
    TT: { amount: constants.Zero, decimals: 18, display: 'TT' },
  },
  gladiator: {
    total: '0.00',
    claimables: '0.00',
    lastSeen: null,
    weekPlayed: '0.00',
    champions: [],
  },
  knight: {
    pmtAllowance: constants.Zero,
    queenId: 0,
    seatFee: 0.05,
    // currentIndex: null,
    // totalPrincipal: 0,
    maxBet: 3000,
    punishRatio: 0.05,
    minJoin: 0,
    list: [],
  },
  network: {
    defaultProvider: readonly,
    providers: {
      readonly,
    },
    isReadOnly: true,
    error: null,
    blockNumber: 0,
  },
  actions: {},
  wallet: {},
}

export function GlobalReducer(state: AppGlobalState, action: any) {
  switch (action.type) {
    case 'SET_PROVIDER':
      return {
        ...state,
        network: {
          ...state.network,
          isReadOnly: action.payload.isReadOnly,
          defaultProvider: action.payload.defaultProvider,
          providers: {
            ...state.network.providers,
            ...action.payload.providers,
          },
        },
      }
    case 'NETWORK_ERROR':
      return {
        ...state,
        network: {
          ...state.network,
          error: action.payload,
        },
      }
    case 'GAME_STATE':
      return {
        ...state,
        balances: {
          ...state.balances,
          ...action.payload.balances,
        },
        gladiator: {
          ...state.gladiator,
          ...action.payload.gladiator,
        },
        knight: {
          ...state.knight,
          ...action.payload.knight,
        },
        network: {
          ...state.network,
          ...action.payload.network,
        },
      }
    case 'ERROR':
      return {
        ...state,
        error: action.payload,
      }
    default:
      throw new Error('Invalid action')
  }
}

export default function useGlobalReducer() {
  return useReducer(GlobalReducer, initState)
}
